import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'readMorePipe'
})

export class ReadMorePipe implements PipeTransform {
  transform(data: string, length: number): string {
    if (data && data.length > length) {
      let readMore = data.substring(0, length);
      return readMore;
    }
    return data;
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipe/read-more.pipe.ts